<template>
  <div id="app">
    <Header
      :numCorrect="numCorrect"
      :numTotal="numTotal"
    />

    <b-container class="bv-example-row">
      <b-row class="justify-content-md-center">
        <b-col lg="6" class="poser">
          
          <div class="homeClass" @click="restart">
            <img width="70px" height="70px" src="https://www.rawshorts.com/freeicons/wp-content/uploads/2017/01/blue_repicthousebase_1484336386-1.png"/>
          </div>

          <a href="https://mystic-peanut.com">
            <div class="madeByMPClass">
            </div>
          </a>

          <transition 
            name="category-selected"
            v-on:after-leave="afterCategorySelected">
            <SelectCategory 
              v-if="quizHome && token.length"
              :start="start"
              :categorySelected="categorySelected"
            />
          </transition>

          <transition 
            name="category-selected"
            v-on:after-leave="afterQuestionsLeft">
              <QuestionBox
                v-if="questions.length && quizStarted && !finishing && !quizFinished && !homePressed"
                :currentQuestion="questions[index]"
                :next="next"
                :index="index+1"
                :increment="increment"
              />
          </transition>

          <transition 
            name="category-selected"
            v-on:after-leave="afterQuestionsLeft">
            <Finish
              v-if="quizFinished && !homePressed && !startRepeating"
              :numCorrect="numCorrect"
              :numTotal="numTotal"
              :restart="restart"
              :repeat="repeat"
            />
          </transition>

        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Finish from './components/Finish.vue'
import QuestionBox from './components/QuestionBox.vue'
import SelectCategory from './components/SelectCategory.vue'

export default {
  name: 'app',
  components: {
    Header,
    Finish,
    QuestionBox,
    SelectCategory
  },
  data() {
    return {
      questions: [],
      index: 0,
      numCorrect: 0,
      numTotal: 0,
      quizStarted: false,
      quizFinished: false,
      finishing: false,
      homePressed: false,
      startRepeating: false,
      quizHome: true,
      categorySelected: 'none',
      token: ''
    }
  },
  methods: {
    next() {
      this.index++
      //if (! this.questions[this.index]) {
      if (this.index == 10) {
        this.finishing = true
      }
    },
    repeat() {
      this.index = 0
      this.startRepeating = true
    },
    // eslint-disable-next-line
    afterCategorySelected: function (el) {
      this.quizStarted = true
      this.homePressed = false
    },
    // eslint-disable-next-line
    afterQuestionsLeft: function (el) {
      if (this.homePressed) {
        this.quizStarted = false
        this.categorySelected = 'none'
        this.numCorrect = 0
        this.numTotal = 0
        this.index = 0
        this.quizFinished = false
        this.homePressed = false
        this.quizHome = true
      }
      if (this.finishing) {
        this.finishing = false
        this.quizFinished = true
      }
      if (this.startRepeating) {
        this.startRepeating = false;
        this.quizFinished = false;
        this.numCorrect = 0
        this.numTotal = 0
        this.quizStarted = true
      }
    },
    restart() {
      if (this.quizStarted) {
        this.quizStarted = false
        this.homePressed = true
      }
      if (this.quizFinished) {
        this.quizFinished = false
        this.homePressed = true
      }
    },
    start(category) {
      if (category == 'animals') {
        fetch('https://opentdb.com/api.php?amount=10&category=27&type=multiple&token='+this.token, {
          method: 'get'
        })
          .then((response) => {
            return response.json()
          })
          .then((jsonData) => {
            console.log(jsonData)
            if (jsonData.response_code == 4) {
              // reset the token
              fetch('https://opentdb.com/api_token.php?command=reset&token='+this.token, {
                method: 'get'
              })
                .then((response) => {
                  return response.json()
                })
                .then((jsonData) => {
                  // todo: after reseting token we should check response code
                  // token reseting means we can keep the same token, no need store new one like this.token = jsonData.token
                  console.log(jsonData)
                  this.start(category)
                })
            } else {
              this.questions = jsonData.results
              this.categorySelected = category
              this.quizHome = false
            }
          })
      }
      if (category == 'books') {
        fetch('https://opentdb.com/api.php?amount=10&category=10&type=multiple&token='+this.token, {
          method: 'get'
        })
          .then((response) => {
            return response.json()
          })
          .then((jsonData) => {
            console.log(jsonData)
            if (jsonData.response_code == 4) {
              // reset the token
              fetch('https://opentdb.com/api_token.php?command=reset&token='+this.token, {
                method: 'get'
              })
                .then((response) => {
                  return response.json()
                })
                .then((jsonData) => {
                  console.log(jsonData)
                  this.start(category)
                })
            } else {
              this.questions = jsonData.results
              this.categorySelected = category
              this.quizHome = false
            }
          })
      }
      if (category == 'geography') {
        fetch('https://opentdb.com/api.php?amount=10&category=22&difficulty=easy&type=multiple&token='+this.token, {
          method: 'get'
        })
          .then((response) => {
            return response.json()
          })
          .then((jsonData) => {
            console.log(jsonData)
            if (jsonData.response_code == 4) {
              // reset the token
              fetch('https://opentdb.com/api_token.php?command=reset&token='+this.token, {
                method: 'get'
              })
                .then((response) => {
                  return response.json()
                })
                .then((jsonData) => {
                  console.log(jsonData)
                  this.start(category)
                })
            } else {
              this.questions = jsonData.results
              this.categorySelected = category
              this.quizHome = false
            }
          })
      }
      if (category == 'sports') {
        fetch('https://opentdb.com/api.php?amount=10&category=21&difficulty=easy&type=multiple&token='+this.token, {
          method: 'get'
        })
          .then((response) => {
            return response.json()
          })
          .then((jsonData) => {
            console.log(jsonData)
            if (jsonData.response_code == 4) {
              // reset the token
              fetch('https://opentdb.com/api_token.php?command=reset&token='+this.token, {
                method: 'get'
              })
                .then((response) => {
                  return response.json()
                })
                .then((jsonData) => {
                  console.log(jsonData)
                  this.start(category)
                })
            } else {
              this.questions = jsonData.results
              this.categorySelected = category
              this.quizHome = false
            }
          })
      }
      
    },
    increment(isCorrect) {
      if (isCorrect) {
        this.numCorrect++
      }
      this.numTotal++
    }
  },
  mounted: function() {
    fetch('https://opentdb.com/api_token.php?command=request', {
      method: 'get'
    })
      .then((response) => {
        return response.json()
      })
      .then((jsonData) => {
        console.log(jsonData)
        this.token = jsonData.token
      })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 2px;
}
.poser {
  position: relative;
}

.homeClass {
  cursor: pointer;
  width:70px;
  height:70px;
  position: absolute;
  top: -45px;
  left: 45px;
  z-index: 100;
}

.madeByMPClass {
  cursor: pointer;
  width: 112px;
  height: 48px;
  border-radius: 12px;
  position: absolute;
  top: -32px;
  right: 48px;
  z-index: 100;
  background-image: url("/madebymp5.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

/* category selected animations */

.category-selected-enter-active {
  transition: opacity .5s;
}

.category-selected-leave-active {
  transition: opacity .5s;
}

.category-selected-enter {
  opacity: 0;
}

.category-selected-leave-to {
  opacity: 0;
}


</style>
